var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5239 9.75272C20.8848 5.81932 17.5438 2.89308 13.5605 2.77789C13.3711 2.77047 13.1865 2.83866 13.0475 2.96743C12.9084 3.0962 12.8262 3.27499 12.8191 3.46439V3.46439V3.52846L13.2676 10.2378C13.297 10.6895 13.6853 11.0328 14.1372 11.0067L20.8649 10.5582C21.0544 10.5442 21.2306 10.4552 21.3543 10.3108C21.478 10.1665 21.539 9.97882 21.5239 9.78933V9.75272Z",
    stroke: "#8083A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90151 6.76779C9.32947 6.6688 9.76741 6.88777 9.94499 7.28953C9.9915 7.38403 10.0195 7.48656 10.0274 7.59159C10.1189 8.89136 10.3111 11.738 10.421 13.2758C10.4397 13.5528 10.5681 13.8109 10.7777 13.993C10.9872 14.1751 11.2608 14.2662 11.5377 14.2461V14.2461L17.1853 13.8982C17.4374 13.8831 17.6846 13.9728 17.8683 14.1461C18.052 14.3194 18.156 14.561 18.1555 14.8136V14.8136C17.9266 18.2239 15.4764 21.075 12.1392 21.814C8.80201 22.553 5.37718 21.003 3.72988 18.0081C3.23813 17.1461 2.92672 16.1932 2.81455 15.2072C2.7666 14.9045 2.74821 14.598 2.75963 14.2918C2.76935 10.6498 5.32714 7.51175 8.89236 6.76779",
    stroke: "#8083A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPie);
export default __webpack_public_path__ + "static/media/ChartPie.0e06b1a6.svg";
export { ForwardRef as ReactComponent };